import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getTrips(companyId, query) {
	return dataTransferWrap(
		ModulesMap.TRIPS,dtConfig[ModulesMap.TRIPS].getTrips,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}
function getTrip(companyId, query) {
	return dataTransferWrap(
		ModulesMap.TRIPS,dtConfig[ModulesMap.TRIPS].getTrip,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}
function getTripsPopup(companyId, machineId, query) {
	return dataTransferWrap(
		ModulesMap.TRIPS,dtConfig[ModulesMap.TRIPS].getTripsPopup,
		{
			urlParams: {
				companyId: companyId,
				machineId,
			},
			params: query,
		},
	)
}
function getTripsPreview(companyId, machineId, query) {
	return dataTransferWrap(
		ModulesMap.TRIPS,dtConfig[ModulesMap.TRIPS].getTripsPreview,
		{
			urlParams: {
				companyId: companyId,
				machineId,
			},
			params: query,
		},
	)
}

export default {
  getTrips,
  getTrip,
  getTripsPopup,
  getTripsPreview,
	
}